<section
  class="rs-content-wrapper rs-header-has-level2"
  id="mobileLevelTwo"
  *ngIf="!hasError || selectedProduct || isPending"
>
  <mprd-skeleton-mobile-level-two
    *ngIf="!selectedProduct"
  ></mprd-skeleton-mobile-level-two>
  <main id="maincontent" role="main" *ngIf="selectedProduct">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1
            class="rs-tit1-sp rs-txt-c2 rs-has-subtit"
            data-cy="mobileLevelTwoDescription"
          >
            {{ selectedProduct?.productDescription }}
          </h1>
          <p
            class="rs-txt-s5 rs-txt-c2 small-only-text-center"
            x-ms-format-detection="none"
          >
            <mprd-access-number-formatter
              [accessNumber]="selectedProduct?.accessNumber"
              [plc]="selectedProduct?.plc"
            ></mprd-access-number-formatter>
          </p>
          <ng-container *ngIf="!isScarlet">
            <a
              href="javascript:void(0)"
              [routerLink]="['/details/mobile/joint-offer']"
              class="rs-btn rs-btn-third rs-btn-neg"
              *ngIf="selectedProduct && jointOffer && isEBU === false"
              data-cy="jointOfferButton"
              >{{ "mobile.jointOffer.manage" | translate
              }}<i
                class="rs-icon-btn-third rs-margin-left1"
                aria-hidden="true"
              ></i
            ></a>
            <a
              href="{{ 'mobile.noJointOffer.catalogueLink' | translate }}"
              target="_blank"
              class="rs-btn rs-btn-third rs-btn-neg"
              *ngIf="selectedProduct && !jointOffer && isEBU === false"
              data-tms-event="link-click"
              data-tms-link-zone="mobile options"
              attr.data-tms-link-name="{{
                'mobile.noJointOffer.catalogue' | translate
              }}"
              attr.data-tms-link-url="{{
                'mobile.noJointOffer.catalogueLink' | translate
              }}"
              data-cy="jointOfferMarketing"
              >{{ "mobile.noJointOffer.catalogue" | translate
              }}<i
                class="rs-icon-btn-third rs-margin-left1"
                aria-hidden="true"
              ></i
            ></a>
          </ng-container>

          <div class="panel rs-panel-big clearfix">
            <div
              *ngIf="
                isUrBuyingEnabled &&
                selectedProduct &&
                !isMyMobile &&
                isRes &&
                isAu
              "
              class="panel rs-bg-grey2 jsrs-clickable rs-clickable"
            >
              <div
                class="rs-flex-row rs-flex-bottom rs-flex-dir-col-small-only"
              >
                <div class="rs-flex-column">
                  <h2 class="rs-tit6 rs-txt-c1">
                    {{ "mobile.urBuying.title" | translate }}
                  </h2>
                  <p>{{ "mobile.urBuying.description" | translate }}</p>
                </div>
                <div class="rs-flex-column rs-flex-shrink">
                  <a
                    [routerLink]="['/user-access-management']"
                    class="rs-btn rs-btn-third"
                  >
                    {{ "mobile.urBuying.link" | translate }}
                    <i
                      class="rs-icon-btn-third rs-margin-left1"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
            <mprd-usage-header
              [product]="selectedProduct"
              [remainingDaysLabel]="remainingDaysLabel"
              *ngIf="remainingDaysLabel"
            ></mprd-usage-header>
            <div class="row" data-masonry-container="">
              <div
                class="columns small-12 medium-6"
                data-masonry-item-sizer=""
              ></div>
              <div class="columns small-12 medium-6" data-masonry-item="">
                <div class="rs-margin-bottom2">
                  <px-usage-level-2-container
                    [product]="usageProduct"
                    [splitBillData]="splitBillData"
                    (usageRemainingDays)="usageInitializedWith($event)"
                  ></px-usage-level-2-container>
                </div>
              </div>
              <mprd-pricing-plan
                [customerAccount]="customerAccount"
                [mobileProductDetails]="selectedProduct"
                *ngIf="isEBU === false"
              ></mprd-pricing-plan>
              <mprd-sim-container
                (refreshInceptionEventEmitter)="initMasonry()"
              ></mprd-sim-container>
              <mprd-change-fav-app></mprd-change-fav-app>
              <ng-container *ngIf="isProductOfferEligibleForPenalty">
                <div class="columns small-12 medium-6" data-masonry-item="">
                  <mprd-jo-renewal-card
                    [product]="selectedProduct"
                  ></mprd-jo-renewal-card>
                </div>
              </ng-container>
              <div
                class="columns small-12 medium-6"
                data-masonry-item=""
                *ngIf="isEBU === false"
              >
                <px-bipt
                  *ngIf="selectedProduct && isRes"
                  [plc]="selectedProduct.plc"
                  [serviceId]="selectedProduct.accessNumber"
                  [analyticsLocation]="'mobile options'"
                  (displayBipt)="initBipt()"
                ></px-bipt>
              </div>
            </div>

            <div class="rs-me"></div>

            <ng-container *ngIf="showAllAvailableOptions; else tplPersonalizedSubscriptions">
              <mprd-available-options-container
                *ngIf="!isUr || isEBU || isUrBuyingEnabled"
                id="available-options"
                data-cy="availableOptionsContainer"
              ></mprd-available-options-container>
            </ng-container>

            <mprd-available-settings-container
              data-cy="availableSettingsContainer"
              *ngIf="isEBU === false"
            ></mprd-available-settings-container>
          </div>

          <div class="rs-mh-s2 rs-mh-m6"></div>

          <div class="rs-le2"></div>
        </div>
      </div>
      <!-- START - FAQ -->
      <div [innerHtml]="faqHtml"></div>
      <!-- END - FAQ -->
    </section>
  </main>
</section>

<ng-template #tplPersonalizedSubscriptions>
  <h2 class="rs-tit3">{{ 'common.options' | translate }}</h2>
  <div class="rs-flex-row">
    <div class="rs-flex-columns small-12 medium-6" (click)="onClickPersonalizedOptionsCtaBanner()" (keydown.enter)="onClickPersonalizedOptionsCtaBanner()" [innerHTML]="'eshare.mobile.optionCtaBanner' | translate"></div>
  </div>
</ng-template>

